import { useImageList } from '@iheartjane/react-image-list'
import { isEmpty } from 'lodash'
import React from 'react'
import { useForm, useFormState } from 'react-final-form'
import { Form } from 'semantic-ui-react'

export const CreateActions = () => {
  const { submitting, pristine, errors } = useFormState()
  const { resetImages } = useImageList()
  const { reset } = useForm()
  const hasErrors = !isEmpty(errors)

  const handleReset = () => {
    const userConfirm = window.confirm(
      'Any unsaved changes will be lost. Would you like to proceed?'
    )
    if (userConfirm) {
      reset()
      resetImages()
    }
  }

  return (
    <>
      <Form.Button disabled={submitting || pristine} onClick={handleReset} type="button">
        Reset
      </Form.Button>
      <Form.Button primary disabled={submitting || pristine || hasErrors} type="submit">
        Create
      </Form.Button>
    </>
  )
}
